module.exports = __webpack_public_path__ + "static/img/bg-id.19d1e40e.webp";